import { axiosInstance } from "../utils/ApiClient";

export const revenueMetricsService = {
  // Get team revenue metrics for the current calendar quarter (PAN-819/PAN-882: the
  // backend always answers for the quarter and names it in `time_window`).
  getTeamRevenueMetrics: async () => {
    try {
      const response = await axiosInstance.get("/metrics/team-revenue/");
      return response.data;
    } catch (error) {
      console.error("Error fetching team revenue metrics:", error);
      throw error;
    }
  },

  // Realized current-quarter NRR driver amounts for the Revenue Goal widget (roadmap #12).
  // Buckets: expansion, renewal, retention (negative), current_total — each `{ amount: "<decimal>" }`.
  // PAN-568 additionally returns a `goal` sub-key per bucket carrying the frozen per-quarter goal.
  // `teamWide: true` skips the sidebar owner scope (team-level config surfaces).
  getNrrGoalProgress: async ({ teamWide = false } = {}) => {
    try {
      const response = await axiosInstance.get("/metrics/nrr-goal-progress/", {
        params: { include_pipeline: true },
        skipOwnerScope: teamWide,
      });
      return response.data;
    } catch (error) {
      // warn, not error: this endpoint can legitimately 404 in the window before the
      // backend deploys (the widget falls back to €0). The caller swallows + degrades.
      console.warn(
        "Could not fetch NRR goal progress (widget falls back to €0):",
        error,
      );
      throw error;
    }
  },

  // PAN-568 Phase 7 — leader-commit for the Expansion bucket's per-quarter goal.
  // bucket is 'expansion' (default) or 'renewal' — the backend accepts 'renewal'
  // only for teams with renewal_goal_frozen (PAN-639). It enforces admin-only
  // and rejects any quarter_label that isn't the team's current fiscal quarter.
  //
  // @param {object} args
  // @param {string} args.quarterLabel - e.g. "2026-Q4"; must match team's current quarter
  // @param {string|number} args.amountMrr - decimal string ok
  // @param {string|number|null} args.pctAtSet - null when hand-typed dollar
  // @param {string} [args.bucket] - "expansion" (default) or "renewal"
  commitTeamQuarterGoal: async ({
    quarterLabel,
    amountMrr,
    pctAtSet,
    bucket = "expansion",
  }) => {
    const body = {
      bucket,
      quarter_label: quarterLabel,
      amount_mrr: String(amountMrr),
      pct_at_set:
        pctAtSet === null || pctAtSet === undefined ? null : String(pctAtSet),
    };
    const response = await axiosInstance.post(
      "/metrics/team-quarter-goal/",
      body,
    );
    return response.data;
  },
};
